module.exports = __webpack_public_path__ + "static/img/bf-btn-off.e445fb18.png";